module.exports = __webpack_public_path__ + "70bafcaaadad9e17b9c7784abbc6b1c2.eot";


//////////////////
// WEBPACK FOOTER
// ./~/clarity-ui/dist/fonts/open-sans-semibold-italic.eot
// module id = 675
// module chunks = 0